import { combine } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { spec, validators } from 'utils/validation'

import ConfirmFormComponent from './component'

const { string, custom, any } = validators

export const ConfirmForm = combine(
  withFormModel(
    (_state, { initialValues }) => ({
      email: {
        initialValue: initialValues.email,
        spec: spec.flow(
          string.isString,
          string.isEmail,
          string.isNotEmpty,
          any.required
        ),
      },

      password: spec.flow(string.isString, string.isNotEmpty, any.required),

      confirmation: spec.flow(
        string.isString,
        custom.matchProp('password'),
        string.isNotEmpty,
        any.required
      ),
    }),
    { id: 'confirm-form' }
  )
)(ConfirmFormComponent)
